<template>
  <div class="body-container login">
    <div class="login-title">欢迎登录</div>
    <div class="login-box">
      <div class="input-box">
        <i class="icon-shouji"></i>
        <input type="number" :placeholder="isCheckMobile == 1 ? '请输入手机号' : '请输入投保人手机号'" v-model.trim="account" />
      </div>
      <div class="input-box">
        <i class="icon-yanzhengma"></i>
        <input type="number" placeholder="请输入验证码" v-model.trim="code" />
        <div
          class="code-btn blue"
          @click="
            getCodeAjax(account);
            sended = true;
          "
          v-if="codeIndex == CODE_SIZE"
        >
          {{ sended ? '重新发送' : '获取验证码' }}
        </div>
        <div class="code-btn" v-else>{{ codeIndex }}S</div>
      </div>
      <van-button round class="form-btn" @click="submit">登录</van-button>
    </div>
  </div>
</template>

<script>
import { common, codeTools } from '@/api/mixins';
export default {
  mixins: [common, codeTools],
  components: {
  },
  data() {
    return {
      // 是否是来自出单实时播报
      isCheckMobile: sessionStorage.loginPage && sessionStorage.loginPage.includes('/m/order/issue') ? 1 : 0,
      appid: '',
      account: '',
      code: '',
      sended: false
    };
  },
  mounted() {
    if (this.$tools.isWeiXin() && !localStorage.bdgj_openid && (!sessionStorage.wxAuthCount || sessionStorage.wxAuthCount <= 3)) {
      this.$weixin.jumpAuth();
      return;
    }
    if (this.$config.env == '2') {
      this.account = '15697158966';
      this.account = '13555555555';
    }
    this.$weixin.hideMenu();
  },
  methods: {
    loginSuccess() {
      let href = '';
      if (this.$route.query.goPage) {
        href = this.$route.query.goPage;
      } else if (sessionStorage.loginPage) {
        href = sessionStorage.loginPage;
      } else {
        href = '/m/personal/index';
      }
      location.replace(href);
    },
    goLogin() {
      const query = Object.assign({}, this.$route.query);
      query.account = this.account;
      this.goPage('/m/login', this.$route.query);
    },
    submit() {
      if (!this.$regulars.isPhone(this.account)) {
        this.$notice.msg('请输入正确的手机号码');
        return;
      } else if (!this.code) {
        this.$notice.msg('请输入验证码');
        return;
      }
      const params = {
        isCheckMobile: this.isCheckMobile,
        mobile: this.account,
        isFromWx: 0,
        code: this.code
      };
      if(localStorage.bdgj_openid) {
        params.openId = localStorage.bdgj_openid;
        params.isFromWx = 1;
      }
      this.loading = true;
      this.$http({
        type: 'PUT',
        url: '/api/bplat/loginByMobile',
        data: params
      })
        .then(resData => {
          localStorage.token = resData.data.token;
          localStorage.user = JSON.stringify(resData.data.data);
          this.loading = false;
          this.loginSuccess();
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './login';
</style>
